import { render, staticRenderFns } from "./AddQuantityOrder.vue?vue&type=template&id=2127bfcb"
import script from "./AddQuantityOrder.vue?vue&type=script&lang=js"
export * from "./AddQuantityOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports